import React from "react";
import "./ButtonRedirect.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ButtonRedirect = () => {
  const { t } = useTranslation();

  return (
    <Link to="/view" className="container-redirect-component">
      <div className="redirect-v2-input-component">
        <div className="background-layer">
          <div className="redirect-button-v2">
            <span className="text-redirect-button">{t('text-redirect-button')}</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ButtonRedirect;
